/*
 * Copyright (c) 2008-2020 by teambits GmbH, Darmstadt, Germany (http://www.teambits.de). All rights reserved.
 * This is CONFIDENTIAL code. Use is subject to license terms.
 */
/* eslint-env node */

export const PORT = "80"
export const HOST =
  process.env.NODE_ENV === "production" ? "" : window.location.protocol + "//" + window.location.hostname + ":" + PORT

/**
 * Needed for join code url to get the full server URL
 */
export const FULL_HOST =
  process.env.NODE_ENV === "production"
    ? window.location.origin
    : window.location.protocol + "//" + window.location.hostname + ":" + PORT

/**
 * The host of the OAuth2 authorization service
 */
export const AUTH_HOST = HOST

/**
 * The hosts used for API access (including exports)
 */
export const API_HOST = HOST + "/api"
export const EXPORTS_HOST = HOST

/**
 * URL for starting clients
 */
export const CLIENTS = FULL_HOST + "/app/join.jsp"

/**
 * URL for clients joining via a joinCode
 */
export const CLIENTS_JOINCODE = HOST

/**
 * URL for starting meeting cockpits
 */
export const MEETING_COCKPIT = HOST + "/cockpit/download"

/**
 * URL for starting feedback client
 */
export const FEEDBACK_CLIENT = HOST + "/simplefeedbackview/feedback.jsp"

/**
 * URL to request the available voting images from
 */
export const VOTING_IMAGE_URL = HOST + "/app/voting-images/"

/**
 * URL to request the available interaction images from
 */
export const INTERACTION_IMAGE_URL = HOST + "/app/interaction-images/"

/**
 * return url to start STAGE client in meetingId
 * @param meetingId
 * @return {string}
 */
export function STAGE(meetingId) {
  return CLIENTS + "?s=STAGE&p=STAGE&m=" + meetingId
}

/**
 * return url to start PREVIEW client in meetingId
 * @param meetingId
 * @return {string}
 */
export function PREVIEW(meetingId) {
  return CLIENTS + "?s=PREVIEW&p=PREVIEW&m=" + meetingId
}

/**
 * return url to start STAGE client in meetingId
 * @param meetingId
 * @return {string}
 */
export function STAGE_EMBEDDED(meetingId) {
  return CLIENTS + "?s=STAGE&p=CC_STAGE&wrapperType=WebMC&m=" + meetingId
}

/**
 * return url to start PREVIEW client in meetingId
 * @param meetingId
 * @return {string}
 */
export function PREVIEW_EMBEDDED(meetingId) {
  return CLIENTS + "?s=PREVIEW&p=CC_PREVIEW&wrapperType=WebMC&m=" + meetingId
}

/**
 * return url to start PARTICIPANT client in meetingId
 * @param meetingId
 * @return {string}
 */
export function PARTICIPANT_EMBEDDED(meetingId) {
  return CLIENTS + "?s=PARTICIPANT&p=CC_PARTICIPANT&wrapperType=WebMC&m=" + meetingId
}

/**
 * return URL of the specified voting image
 * @return {string}
 */
export function VOTING_IMAGE(fileName) {
  return VOTING_IMAGE_URL + fileName
}

/**
 * return url to simple feedback view for meetingId
 * @param meetingId
 * @return {string}
 */
export function SIMPLE_FEEDBACK_VIEW(meetingId) {
  return FEEDBACK_CLIENT + "?meetingId=" + meetingId
}
